export const API_ENDPOINTS = {
    PARTICIPANTS: {
        GET_COMPANY_BY_ID: "Company/GetById",
        SEARCH_COMPANY: "Company/Search",
        EXPORT_COMPANY: "Company/Export",
        SAVE_COMPANY: "Company/Save",
        UPDATE_COMPANY: "Company/Update",
        DELETE_COMPANY: "Company/Delete",
        GET_COMPANY_BY_CUSTOMER: "Company/GetByCustomerId",
        SEARCH_CUSTOMER: "Customer/Search",

        GET_POLICYHOLDER_BY_ID: "PolicyHolder/GetById",
        GET_POLICYHOLDER_BY_DETAIL: "PolicyHolder/Detail",
        GET_COMPANY_BY_DETAIL: "Company/GetDetailById",
        SEARCH_POLICYHOLDER: "PolicyHolder/Search",
        EXPORT_POLICYHOLDER: "PolicyHolder/Export",
        EXPORT_POLICYHOLDER_CLAIM: "PolicyHolder/GetClaimDetailExport",
        SAVE_POLICYHOLDER: "PolicyHolder/Save",
        SAVE_POLICYHOLDER_DEPENDENT: "/PolicyHolder/SaveDependent",
        UPDATE_POLICYHOLDER: "PolicyHolder/Update",
        DELETE_POLICYHOLDER: "PolicyHolder/Delete",
        GET_POLICYHOLDER_PROFILE: "PolicyHolder/Profile",

        ACTIVATE_POLICY: "policy/ReSync",
        SAVE_BULK_POLICYHOLDER: "PolicyHolder/SaveBulk",
        RESYNC_POLICY: "policy/ReSync",
        CANCEL_POLICY_HOLDER: "policy/CancelPolicyHolder",
        GET_CLAIM_DETAIL: "PolicyHolder/GetClaimDetail",
        GET_USERS: "Company/GetUsers",
        SEARCH_COMPANY_SERVICE: "/CompanyService/Search",
        SAVE_COMPANY_SERVICE: "/CompanyService/Save",
        SAVE_USER: "User/Save",
        GET_USER_BY_ID: "User/GetById",
        UPDATE_USER: "User/Update",
        SEARCH_POLICYHOLDER_DEPENDENT: "PolicyHolder/GetDependent",
        UPDATE_POLICYHOLDER_CONTACT: "PolicyHolder/UpdateContact",
        // Add other  endpoints here

    },
    EXCEPTIONS: {
        SEARCH: "CompanyException/Search",
        GET_BY_ID: "CompanyException/GetById",
        DELETE: "CompanyException/DeleteAgreement",
        DELETE_EXCEPTION: "CompanyException/DeleteException",
        EXPORT: "CompanyException/Export",
        SAVE: "CompanyException/Save",
        UPDATE: "CompanyException/Update",
        CHECK_CODE: "CompanyException/CodeExists",
        UPLOAD_AGREEMENT: "/CompanyException/UploadAgreement"
    }

    // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    PARTICIPANTS: {
        COMPANY: ["CompanySearch", "CompanyDetail", "CompanyBulk", "PolicySearch", "PolicyHolderSearch", "PolicyHolderDetail"],
        COMPANY_BULK: ["CompanyBulk"], 
        CUSTOMER_BULK: ["CustomerBulk"], 
        POLICYHOLDERS: ["PolicyHolderSearch"],
        POLICY: ["PolicyHolderSearch"],
        GET_POLICYHOLDER_DETAIL: ["PolicyHolderDetail"],
        GET_COMPANY_DETAIL: ["CompanyDetail"],
        COMPANY_SERVICE: ["CompanyServiceSearch"],
        GET_DEPENDENT_HOLDERS: ["PolicyHolderDependent"],
        GET_CLAIM_SUMMARY: ["PolicyHolderClaimSummary"],
        GET_POLICYHOLDER_PROFILE: ["PolicyHolderProfile"]
         //POLICYHOLDERS: ["PolicyHolderSearch", "PolicySearch", "PolicyHolderSearch"],
        //COMPANY_DETAIL: ["CompanySearch"], // UNIQUE IN OVER ALL APPLICATION
         //COMPANY: ["CompanySearch", "CompanyDetail", "Companybulk", "PolicySearch", "PolicyHolderSearch", "PolicyHolderDetail"], // UNIQUE IN OVER ALL APPLICATION
    },
    EXCEPTIONS: {
        EXCEPTIONS: ["CompanyExceptions"]
    }
};
